const STORAGE_KEY = 'session_expired_notification';

function canUseSessionStorage() {
    try {
        return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
    } catch (e) {
        return false;
    }
}

function resolveLoginUrl(pathname = '') {
    return pathname.startsWith('/admin') ? '/admin/login' : '/login';
}

function persistSessionExpiredNotification(notification) {
    if (!canUseSessionStorage()) {
        return;
    }

    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(notification));
}

function consumeSessionExpiredNotification() {
    if (!canUseSessionStorage()) {
        return null;
    }

    const rawValue = window.sessionStorage.getItem(STORAGE_KEY);

    if (!rawValue) {
        return null;
    }

    window.sessionStorage.removeItem(STORAGE_KEY);

    try {
        return JSON.parse(rawValue);
    } catch (e) {
        return null;
    }
}

function extractMessage(response) {
    return response?.responseJSON?.message
        || response?.responseJSON?.error
        || response?.data?.message
        || response?.data?.error
        || null;
}

function extractDescription(response) {
    return response?.responseJSON?.description
        || response?.data?.description
        || null;
}

function isSessionExpiredResponse(response) {
    if (!response) {
        return false;
    }

    if (response.status === 419) {
        return true;
    }

    if (response.status !== 401) {
        return false;
    }

    return extractMessage(response) === 'Unauthenticated.';
}

function redirectToLoginWithSessionExpiredMessage(response, fallbackUrl = resolveLoginUrl(window.location.pathname)) {
    if (!isSessionExpiredResponse(response)) {
        return false;
    }

    persistSessionExpiredNotification({
        type: 'error',
        message: extractMessage(response) || 'Your session has expired.',
        description: extractDescription(response) || 'Please sign in again to continue.',
    });

    window.location.href = fallbackUrl;

    return true;
}

module.exports = {
    consumeSessionExpiredNotification,
    redirectToLoginWithSessionExpiredMessage,
    resolveLoginUrl,
};
